define('cartware_checkout/classes/accordeon',[
	'jquery',
	'lodash',
	'cartware/jquery/bem',
	'cartware_checkout'
], function(
	$,
	_,
	BEM,
	CartwareCheckout
) {
	var animateAttributes = {
		left: 'left'
	};

	if ('transit' in $ && 'undefined' != typeof Modernizr && Modernizr.csstransitions) {
		$.extend(animateAttributes, {
			left: 'x'
		});
	}

	var AccordionReplacement = function(container, options) {
		this.container = container;
		this.stage = this.container.bemGetElements('stage');
		this.stepsContainer = this.stage.bemGetElements('step-list');
		this.steps = this.stepsContainer.bemGetElements('section');
		this.currentStep = this.steps.first();
		this.sidebar = BEM.block('opcheckout-progress-sidebar');

		this.sections = this.steps.toArray();
		this.body = $(document.body);

		this._layout();
		this._initializeEvents();
		this._adviseValidation();

		$(window).on('resize', _.debounce(_.bind(function() {
			this._layout();
			this._position();
		}, this), 100));
	};

	AccordionReplacement.prototype = {
		_layout: function() {
			var containerWidth = this.container.width();

			this.stage.css({
				width: containerWidth * this.steps.length,
				height: Math.max(this.currentStep.outerHeight(true), this.sidebar.is(':visible') ? this.sidebar.outerHeight(true) : 0)
			});

			this.steps.css({
				'width': containerWidth
			});
		},

		_position: function() {
			var targetStyles = {
				height: this.currentStep.outerHeight(true)
			};

			targetStyles[animateAttributes.left] = - this._getTargetLeft(this.currentStep);

			this.stage.stop().animate(targetStyles, {duration: 0, queue: false});
		},

		_getTargetLeft: function(sectionNode) {
			var targetKey = this.steps.index(sectionNode),
				targetLeft = 0;

			this.steps.each(function(i) {
				if (i === targetKey) {
					return false;
				}
				targetLeft += $(this).outerWidth(true);
			});

			return targetLeft;
		},

		_initializeEvents: function() {
			// Fixes a chrome behaviour which scrolls the container when
			// click-drag text on a form element.
			var container = this.container,
				theBody = this.body,
				self = this;

			container.on('click', function() {
				_.delay(function() {
					self._layout();
				}, 10);
			});
		},

		_adviseValidation: function() {
			var self = this,
				_validate = Validation.validate;

			Validation.validate = function() {
				var result = _validate.apply(this, arguments);

				setTimeout(function() {
					self._layout();
				}, 100);

				return result;
			};
		},

		openSection: function(section, options) {
			options = options || {};
			var sectionNode = $('#' + section),
				targetLeft = this._getTargetLeft(sectionNode),
				self = this;

			function scrollToTop(cb) {
				if (options.immediately) {
					$('html, body').scrollTop(0);
					return cb();
				}

				$('html, body').stop(true, false).animate({
					scrollTop: 0
				}, {
					duration: 450,
					easing: 'easeOutSine' in $.easing ? 'easeOutSine' : 'swing',
					complete: function() {
						cb();
					}
				});
			}

			function scrollToSection() {
				self.currentStep = sectionNode;

				setTimeout(function() {
					var targetStyles = {
						height: Math.max(sectionNode.outerHeight(true), self.sidebar.is(':visible') ? self.sidebar.outerHeight(true) : 0)
					};

					var mfpWrap = $('.mfp-wrap ');
					var $document = $(document);

					function onStep() {
						if (mfpWrap.length) {
							mfpWrap.css('top', $document.scrollTop());
						}
					}

					function onComplete() {
						self.currentStep = sectionNode;
					}

					targetStyles[animateAttributes.left] = - targetLeft;

					if (options.immediately) {
						self.stage.css(targetStyles);
						onStep();
						onComplete();
						return;
					}

					self.stage.stop(true, false).animate(targetStyles, {
						queue: false,
						duration: 650,
						easing: 'easeOutSine' in $.easing ? 'easeOutSine' : 'swing',
						complete: onComplete,
						step: onStep
					});
				}, 50);
			}

			scrollToTop(scrollToSection);
		},

		openPrevSection: function() {
			var previousSection = this.currentStep.prev('.section');
			if (previousSection.length) {
				this.openSection(previousSection.attr('id'));
			}
		}
	};

	return AccordionReplacement;
});
